"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.number.constructor");
var _couponExpand = require("@/api/activity/couponExpand");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'expandList',
  components: {},
  props: {
    actId: {
      type: Number,
      default: ''
    }
  },
  watch: {
    actId: {
      immediate: true,
      handler: function handler(newVal) {
        console.log('actId', newVal);
        // 有actId时选中，无actId时不选
        if (newVal && newVal != 'null' && newVal != '') {
          this.searchForm.expandId = newVal;
          this.searchForm.page = 1;
          this.fetchList();
        }
        // this.searchForm.expandId = newVal && newVal != 'null' ? newVal : '';
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      searchForm: {
        status: '',
        expandId: '',
        page: 1,
        limit: 10,
        total: 0,
        mobile: '',
        cardNo: ''
      },
      actLists: [],
      tableData: [],
      showUserDialog: false,
      // 控制弹窗显示
      userList: [],
      searchForm2: {
        status: '',
        page: 1,
        limit: 10,
        total: 0
      },
      searchForm3: {
        status: '',
        page: 1,
        limit: 10,
        total: 0,
        cardNo: '',
        mobile: '',
        expandId: '',
        participateId: ''
      },
      userList2: [],
      dialogVisible: false,
      downloadLoading: false
    };
  },
  computed: {
    maxHeight: function maxHeight() {
      return "".concat(window.innerHeight - 497, "px");
    }
  },
  methods: {
    dateFormat2: function dateFormat2(date, format) {
      var d = date instanceof Date ? date : new Date(date);
      if (isNaN(d.getTime())) return '';
      var map = {
        'yyyy': d.getFullYear(),
        'MM': ('0' + (d.getMonth() + 1)).slice(-2),
        'dd': ('0' + d.getDate()).slice(-2),
        'HH': ('0' + d.getHours()).slice(-2),
        'mm': ('0' + d.getMinutes()).slice(-2),
        'ss': ('0' + d.getSeconds()).slice(-2)
      };
      var fmt = format || 'yyyy-MM-dd HH:mm:ss';
      Object.keys(map).forEach(function (k) {
        fmt = fmt.replace(k, map[k]);
      });
      return fmt;
    },
    getUserList2: function getUserList2() {
      var _this = this;
      (0, _couponExpand.getInventoryList)(this.searchForm3).then(function (res) {
        res.records.forEach(function (item) {
          if (item.createDate) {
            item.createDate = _this.dateFormat2(item.createDate);
          }
        });
        _this.userList2 = res.records || [];
        _this.searchForm3.total = res.total || 0;
      });
    },
    download: function download() {
      var _this2 = this;
      this.downloadLoading = true;
      var params = {
        status: this.searchForm.status,
        expandId: this.searchForm.expandId,
        mobile: this.searchForm.mobile,
        cardNo: this.searchForm.cardNo
      };
      (0, _couponExpand.exportData)(params).then(function (response) {
        var blob = new Blob([response], {
          type: 'application/vnd.ms-excel'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = '膨胀明细.xlsx';
        link.click();
        window.URL.revokeObjectURL(link.href);
      }).finally(function () {
        _this2.downloadLoading = false;
      });
    },
    changeTime: function changeTime(e) {
      console.log(e);
    },
    indexMethod: function indexMethod(index) {
      return (this.searchForm.page - 1) * this.searchForm.limit + index + 1;
    },
    handleSortChange: function handleSortChange(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      this.searchForm.sortField = prop;
      this.searchForm.sortOrder = order === 'ascending' ? 'asc' : order === 'descending' ? 'desc' : '';
      this.fetchList();
    },
    handleTabChange: function handleTabChange(tab) {
      this.activeTab = tab.name;
    },
    fetchList: function fetchList() {
      var _this3 = this;
      this.loading = true;
      console.log(this.searchForm);
      (0, _couponExpand.getJoinList)(this.searchForm).then(function (res) {
        _this3.tableData = res.records || [];
        _this3.searchForm.total = res.total || 0;
      }).finally(function () {
        _this3.loading = false;
      });
    },
    resetForm: function resetForm() {
      this.searchForm = {
        expandId: '',
        page: 1,
        limit: 10,
        total: 0,
        mobile: '',
        cardNo: ''
      }, this.fetchList();
    },
    // 每页条数变化
    handleSizeChange: function handleSizeChange(newSize) {
      this.searchForm.limit = newSize;
      this.searchForm.page = 1;
      this.fetchList();
    },
    // 页码变化
    handlePageChange2: function handlePageChange2(newPage) {
      this.searchForm2.page = newPage;
      this.getUserList();
    },
    handleSizeChange2: function handleSizeChange2(newSize) {
      this.searchForm2.limit = newSize;
      this.searchForm2.page = 1;
      this.getUserList();
    },
    handlePageChange3: function handlePageChange3(newPage) {
      this.searchForm3.page = newPage;
      this.getUserList2();
    },
    handleSizeChange3: function handleSizeChange3(newSize) {
      this.searchForm3.limit = newSize;
      this.searchForm3.page = 1;
      this.getUserList2();
    },
    // 页码变化
    handlePageChange: function handlePageChange(newPage) {
      this.searchForm.page = newPage;
      this.fetchList();
    },
    handleDetail: function handleDetail(row, id) {
      if (id == 1) {
        this.searchForm2.status = '';
        this.searchForm2.page = 1;
        this.searchForm2.participateId = row.id;
        this.getUserList();
        this.showUserDialog = true;
      } else {
        this.searchForm3.page = 1;
        this.searchForm3.participateId = row.id;
        this.getUserList2();
        this.dialogVisible = true;
      }
    },
    getUserList: function getUserList() {
      var _this4 = this;
      (0, _couponExpand.getUserList)(this.searchForm2).then(function (res) {
        _this4.userList = res.records || [];
        _this4.searchForm2.total = res.total || 0;
      });
    },
    getActList: function getActList() {
      var _this5 = this;
      var data = {
        startTime: '',
        endTime: '',
        keywords: '',
        page: 1,
        limit: 99999,
        total: 0
      };
      (0, _couponExpand.getActList)(data).then(function (res) {
        _this5.actLists = res.records || [];
        if (res.records[0] && (_this5.actId == 'null' || _this5.actId == '')) {
          _this5.searchForm.expandId = res.records[0].id;
          _this5.fetchList(res.records[0].id);
        }
      });
    }
  },
  mounted: function mounted() {
    this.getActList();

    // this.fetchList()
  }
};